export enum AnnotationType {
  MARKUP = 'pspdfkit/markup/highlight',
  UNDERLINE = 'pspdfkit/markup/underline',
  STRIKEOUT = 'pspdfkit/markup/strikeout',
  SQUIGGLY = 'pspdfkit/markup/squiggly',
  NOTE = 'pspdfkit/note',
  TEXT = 'pspdfkit/text',
  INK = 'pspdfkit/ink',
  LINE = 'pspdfkit/shape/line',
  POLYGON = 'pspdfkit/shape/polygon',
  POLYLINE = 'pspdfkit/shape/polyline',
  ELLIPSE = 'pspdfkit/shape/ellipse',
  RECTANGLE = 'pspdfkit/shape/rectangle'
}
